import DefaultJsonConfigEditor from "./src/DefaultJsonConfigEditor.vue";
import DefaultEmptyConfigEditor from "./src/DefaultEmptyConfigEditor.vue";
import ETAUKeySignConfigEditor from "./src/ETAUKeySignConfigEditor.vue";
import W3CHSMConfigEditor from "./src/W3CHSMConfigEditor.vue";
import W3CUKeyConfigEditor from "./src/W3CUKeyConfigEditor.vue";
import TestConfigEditor from "./src/TestConfigEditor.vue";
import SwMsgConfigEditor from './src/SwMsgConfigEditor'
import SwMsgHSMDecComponent from './src/SwMsgHSMDecComponent'
import SwMsgHSMDecComponent4Group from './src/SwMsgHSMDecComponent4Group'
import EnvelopingSignConfigEditor from './src/EnvelopingSignConfigEditor'
import TaxClientWrapContent from './src/TaxClientWrapContent'
import CertEncryptConfigEditor from './src/CertEncryptConfigEditor'
let match = type => {
    switch (type) {
        default:
            return 'DefaultJsonConfigEditor';

        case 'NullingComponent':
        case 'DxpClientUnWrapComponent':
        case 'DxpClientR1WrapComponent':
            return 'DefaultEmptyConfigEditor';

        case 'ETAUKeySignComponent':
            return 'ETAUKeySignConfigEditor';

        case 'W3CUKeySignComponent':
        case 'W3CUKeyVerifyComponent':
            return 'W3CUKeyConfigEditor';

        case 'W3CHSMSignComponent':
        case 'W3CHSMVerifyComponent':
            return 'W3CHSMConfigEditor';

        case 'TestComponent':
            return 'TestConfigEditor';

        case 'SwMsgReceCommonComponent':
            return 'SwMsgConfigEditor'
        case 'SwMsgHSMDecComponent':
            return 'SwMsgHSMDecComponent'
        case 'SwMsgHSMDecComponent4Group':
            return 'SwMsgHSMDecComponent4Group'
      case 'EnvelopingSignComponent':
        return 'EnvelopingSignConfigEditor'
      case 'TaxClientWrapComponent':
        return 'TaxClientWrapContent'
      case 'CertEncryptComponent':
        return 'CertEncryptConfigEditor'


    }
}

let editor = {
    match,
    editor: {
        DefaultJsonConfigEditor,
        DefaultEmptyConfigEditor,
        ETAUKeySignConfigEditor,
        W3CHSMConfigEditor,
        W3CUKeyConfigEditor,
        TestConfigEditor,
        SwMsgConfigEditor,
        SwMsgHSMDecComponent,
        SwMsgHSMDecComponent4Group,
      EnvelopingSignConfigEditor,
      TaxClientWrapContent,
      CertEncryptConfigEditor
    }
};

export default editor;

